import CloudIncomingIcon from "./CloudIncomingIcon";
import CloudOutgoingIcon from "./CloudOutgoingIcon";

export default {
  CloudIncomingIcon,
  CloudOutgoingIcon,
};
